import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotion-list',
  templateUrl: './promotion-list.component.html',
  styleUrls: ['./promotion-list.component.scss']
})
export class PromotionListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
